import { FlexBox, Radio } from '@dixa/lib-shared-habla';

import styles from './ResolutionModalBody.module.scss';

type ResolutionRadioInputsProps = {
  name: string;
  noChecked: boolean;
  onCheckNo: () => void;
  onCheckYes: () => void;
  yesChecked: boolean;
};
export function ResolutionRadioInputs({
  name,
  noChecked,
  onCheckNo,
  onCheckYes,
  yesChecked,
}: ResolutionRadioInputsProps): JSX.Element {
  const yesId = `${name}-yes`;
  const noId = `${name}-no`;
  const onChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
    if (e.currentTarget.id === yesId) onCheckYes();
    if (e.currentTarget.id === noId) onCheckNo();
  };

  return (
    <FlexBox flexDirection="column" gap="8px">
      <FlexBox alignItems="center" className={styles.radioWrapper}>
        <Radio
          checked={yesChecked}
          id={yesId}
          name={name}
          onChange={onChange}
        />
        <label htmlFor={yesId} className={styles.radioLabel}>
          Yes
        </label>
      </FlexBox>
      <FlexBox alignItems="center" className={styles.radioWrapper}>
        <Radio checked={noChecked} id={noId} name={name} onChange={onChange} />
        <label htmlFor={noId} className={styles.radioLabel}>
          No
        </label>
      </FlexBox>
    </FlexBox>
  );
}
